import { FilterAttribute } from '@/types/filterAttribute';

export const STEPS: {
  filterAttribute: FilterAttribute;
}[] = [
  { filterAttribute: 'percentOffMsrp' },
  { filterAttribute: 'platforms' },
  { filterAttribute: 'compositeCategories' },
  { filterAttribute: 'specialties' },
  { filterAttribute: 'brands' },
];
